import React from 'react';
import { useNavigate } from 'react-router';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

interface PersonalInfoCardProps {
  completed: number;
  total: number;
  editUrl: string | null;
}

export function PersonalInfoCard({
  completed,
  total,
  editUrl,
}: PersonalInfoCardProps): React.ReactElement {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: '16px', py: '14px' }}
      >
        <Stack spacing="2px">
          <Typography
            sx={{
              color: theme.palette.text.primary,
              fontSize: 15,
              fontWeight: 600,
            }}
          >
            Personal Information
          </Typography>
          <Typography
            sx={{
              color: theme.palette.text.secondary,
              fontSize: 12,
            }}
          >
            {completed} of {total} values completed
          </Typography>
        </Stack>

        {editUrl && (
          <Box
            component="button"
            onClick={() => void navigate(editUrl)}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              fontSize: 13,
              fontWeight: 500,
              borderRadius: '8px',
              px: '12px',
              py: '6px',
              border: 'none',
              cursor: 'pointer',
              textDecoration: 'none',
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            Edit
          </Box>
        )}
      </Stack>
    </Box>
  );
}
